import { useEffect, useRef } from "react";

export const PINNED_CLASS_NAME = "is-pinned";

export const useStickyCondition = () => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([e]) =>
        e?.target.classList.toggle(PINNED_CLASS_NAME, e.intersectionRatio < 1),
      { threshold: [1] },
    );
    ref.current && observer.observe(ref.current);
    () => {
      observer.disconnect();
    };
  }, []);

  return ref;
};
